import { type NodeProps } from "@solidtv/solid";
import { createSignal, Show } from "solid-js";

interface SeasonTabProps extends NodeProps {
  children: string;
  isSelected?: boolean;
  onEnter: () => void;
}

const transitionObj = {
  duration: 150,
  easing: "ease-out"
};

export default function SeasonTab(props: SeasonTabProps) {
  const [focused, setFocused] = createSignal(false);

  return (
    <view
      {...props}
      width={220}
      height={60}
      borderRadius={30}
      color={focused() ? 0xffffffff : (props.isSelected ? 0xffffff22 : 0x000000aa)}
      border={{ width: focused() ? 4 : 0, color: 0xffffffff }}
      scale={focused() ? 1.05 : 1}
      transition={{ scale: transitionObj, color: transitionObj }}
      onFocusChanged={setFocused}
      onEnter={props.onEnter}
      display="flex"
      alignItems="center"
      justifyContent="center"
      forwardStates
    >
      <text
        fontSize={24}
        fontWeight="bold"
        color={focused() ? 0x000000ff : (props.isSelected ? 0xffffffff : 0xaaaaaaff)}
        fontFamily="Roboto"
        y={14}
      >
        {props.children}
      </text>

      {/* Selected indicator underline */}
      <Show when={props.isSelected}>
        <view
          y={44}
          width={80}
          height={4}
          borderRadius={2}
          color={focused() ? 0x000000ff : 0xffffffff}
        />
      </Show>
    </view>
  );
}
